import { Pipe, PipeTransform } from '@angular/core';
import { Vehicle } from 'src/app/shared/models/vehicle';

@Pipe({
	name: 'filterVehiculeByStatus'
})
export class FilterVehiculeByStatusPipe implements PipeTransform {
	transform(vehicules: Vehicle[], filter: string | string[]): Vehicle[] {
		if (
			vehicules === null ||
			filter === '' ||
			filter === [] ||
			filter.length === 0
		) {
			return vehicules;
		}

		if (!Array.isArray(filter)) {
			filter = [filter];
		}
		return vehicules.filter((vehicule) => {
			for (const status of filter) {
				if (vehicule.status === status) {
					return true;
				}
			}
			return false;
		});
	}
}
